import { Component, OnInit, AfterViewInit } from '@angular/core';
import LocomotiveScroll from 'locomotive-scroll';

declare var carousel:any;
declare var scrollNav:any;
declare var splittext01: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: [
  ]
})
export class HomeComponent implements OnInit, AfterViewInit {

  


  constructor() { }

  ngOnInit(): void {


    setTimeout(() => {

      new splittext01();
      scrollNav()
      
      }, 250);
  }

  ngAfterViewInit(): void {
    
  }




}
